import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RecommendationBaseView } from '../../../../sharedComponents/RecommendationBaseView';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddTopicPhraseToMetaDescriptionView = ({
  auditResult
}) => {
  const {
    status,
    topicPhrase
  } = auditResult;
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.ADD_TOPIC_PHRASE_TO_META_DESCRIPTION",
      options: {
        topicPhrase
      }
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_TOPIC_PHRASE_TO_META_DESCRIPTION"
    }),
    status: status
  });
};